import { useState } from 'react';

const read = (key: string): string[] => {
  try { const v: unknown = JSON.parse(localStorage.getItem(key) ?? '[]'); return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : []; }
  catch { return []; }
};

/**
 * A set of ids kept in this browser only: a viewer convenience, not state. Private mode or cleared storage forgets
 * it, so whatever it remembers must be safe to lose. `keep` bounds it; the ids touched longest ago drop off first.
 */
export function useStoredIds(key: string, keep: number) {
  const [ids, setIds] = useState(() => read(key));
  const write = (next: string[]) => {
    setIds(next);
    try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* private mode: kept for this page load */ }
  };
  const set = (id: string, on: boolean) => write(on ? [...ids.filter((x) => x !== id), id].slice(-keep) : ids.filter((x) => x !== id));
  return { has: (id: string) => ids.includes(id), set };
}
